import { Box } from "@mui/material";
import { useState, useEffect, useRef, } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import AuthenticateLayout from "../../components/AuthenticateLayout";
import QRCodeScanDialog from "../../components/QRCodeScanDialog";
import QRScanner from "../../components/QRCodeScanner";
import { Loading } from "../../components";
import { links } from "../../constants/links";
import { LOGIN_METHOD, SUB_CAMPAIGN_ID_KEY } from "../../constants";

import { postEngageAction, validateEngageSession, getSubcampaignCouponDetail, redeemSelfService } from "../../services/ads/ads.service";

import { isExpiredToday } from "../../utils/utils";
import { toInteger } from "lodash";
import isURL from "validator/lib/isURL";

import {
  UseRewardWrapper,
  QRCodeWrapper
} from "./styles/styles";

import { InitialData, CouponTypeEnum, CouponDetail } from "./types";
import { FooterContainer } from "./components/FooterContainer";
import { RedeemCodeContainer } from "./components/RedeemCodeContainer";
import CouponUsedTypeContainer from "./components/CouponUsedTypes";
import { isLineMethod } from "../authenticate/login/components/loginMethods";
import { ENV } from "../../configs/env";


export const ListStatus = {
  PENDING: "PENDING",
  ENGAGED: "ENGAGED",
  COMPLETED: "COMPLETED",
  VERIFIED: "VERIFIED"
};

interface LocationState {
  isFromOtpPage?: boolean;
  isFromPaypayConsentPage?: boolean;
  isFromPaypayCouponPage?: boolean;
}


const UseReward2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [isScanQr, setIsScanQr] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const searchParams = new URLSearchParams(location.search);
  const engage_session_id = useRef(searchParams.get("engage-session") || "");
  const coupon_session_id = useRef(searchParams.get("coupon-session") || "");
  const {
    isFromOtpPage = false,
    isFromPaypayConsentPage = false,
    isFromPaypayCouponPage = false,
  } = location.state as LocationState || {};
  const [isLoadedStatus, setIsLoadedStatus] = useState(true);

  const initialData: InitialData = {
    coupon_code: "",
    qrscan_image: "",
    reward_banner: "",
    used_at: "",
    expired_at: "",
    coupon_used_option: "",
    is_3rdparty_coupon_use: false,
    is_for_verified_users: false,
    is_line_verified: false,
    remain_quantity: 0,
    is_expired_or_finished_issued: false,
    subcampaign_id: "",
    languages: {},
    banner_image_corner: "0",
  };

  const [data, setData] = useState(initialData);
  const [used, setUsed] = useState(false);
  const [isExpired, setIsExpired] = useState(true);
  const [showComponent, setShowComponent] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [openDialog, setOpenDialog] = useState(false);
  const [dialogInfo, setDialogInfo] = useState({
    is_success: false,
    coupon_code: ""
  });

  const clearError = () => setErrorMsg("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowComponent(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const [nav] = performance.getEntriesByType("navigation") as PerformanceNavigationTiming[];
    const navType = nav?.type ?? "navigate";
    const isReload = navType === "reload";

    if (location.pathname.includes("use-reward")) {
      if (engage_session_id.current) {
        validateEngageSession(engage_session_id.current).then((res) => {
          const subcampaign_id = res.data?.["subcampaign_id"];
          const session_id = res.data?.["active_session"];
          //set local storage
          localStorage.setItem("session-id", session_id);
          localStorage.setItem(SUB_CAMPAIGN_ID_KEY, subcampaign_id);
          setData((prevData) => ({
            ...prevData,
            subcampaign_id: subcampaign_id
          }));
          if (
            subcampaign_id !== undefined &&
            !isFromOtpPage &&
            !isFromPaypayConsentPage &&
            !isFromPaypayCouponPage
          ) {
            postEngageAction({
              subcampaign_id: toInteger(subcampaign_id),
              isCouponPage: true,
              engage_session: engage_session_id.current,
              isReload: isReload
            });
            //redirect to loyalty point if have coupon type is loyalty point
          }
        }).catch(() => {
          navigate(`${links.CAMPAIGN_STATUS.replace(":status", "error")}`);
        });
      } else {
        navigate(`${links.CAMPAIGN_STATUS.replace(":status", "error")}`);
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    const handlePopState = (event: any) => {
      if (location.state?.fromPath !== "EARN_REWARD") {
        window.history.pushState(null, "", window.location.pathname);
      }
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);


  useEffect(() => {
    if (isLoadedStatus && data.subcampaign_id) {
      getSubcampaignCouponDetail({
        id: data.subcampaign_id,
        engage_id: engage_session_id.current,
        coupon_session: coupon_session_id.current
      }).then((detailData: CouponDetail) => {
        setData(detailData);

        const {
          status: couponStatus,
          coupon_type: couponType,
          expired_at,
          sending_message_platform,
          is_for_verified_users,
          is_line_verified,
          advertiser_banner,
          qrscan_image,
          reward_banner,
          banner_image_corner,
          loyalty_member_id,
          languages,
          is_loyalty_submitted,
          is_multi_coupons,
          remain_quantity
        } = detailData;

        if (is_multi_coupons) {
          return navigate(
            `${links.MULTI_COUPONS}/?engage-session=${engage_session_id.current}`,
            { replace: true }
          );
        }

        // if (detailData.is_paypay && !detailData.is_paypay_consent_completed) {
        if (detailData.is_paypay && !isFromPaypayCouponPage && !isFromPaypayConsentPage) {

          return navigate(
            `${links.PAY_PAY_COUPON}`,
            {
              state: {
                engageSession: engage_session_id.current,
                couponSession: detailData.coupon_session,
                couponValue: detailData.external_coupon_amount,
                couponCode: detailData.coupon_code,
                createDateISO: detailData.create_date,
                couponExpiredAt: expired_at,
                couponReference: detailData.coupon_reference,
                couponExternalCode: detailData.external_code,
                isPayPayConsentCompleted: detailData.is_paypay_consent_completed,
              }
            }
          );
        }

        if (detailData.is_3rdparty_coupon_use && (!detailData.is_for_verified_users || detailData.is_line_verified)) {
          if (detailData.coupon_code && isURL(detailData.coupon_code)) {
            window.location.href = detailData.coupon_code;
            return;
          } else {
            return navigate(`${links.SMART_RETAIL_ERROR}?error-msg=invalid_url`);
          }
        }

        if (couponStatus === ListStatus.COMPLETED && remain_quantity === 0) {
          setUsed(true);
        }
        if (expired_at) {
          setIsExpired(isExpiredToday(expired_at));
        }
        const sendingMessagePlatform = sending_message_platform || process?.env?.REACT_APP_DEFAULT_APPLICATION;
        if (
          typeof sendingMessagePlatform === "string" &&
          isLineMethod(sendingMessagePlatform) &&
          is_for_verified_users &&
          !is_line_verified &&
          (couponStatus === ListStatus.PENDING || couponStatus === ListStatus.ENGAGED || couponStatus === ListStatus.VERIFIED)
        ) {
          localStorage.removeItem("otp-page-expired");
          localStorage.removeItem("otp-phone-verified");
          return navigate(links.OTP_INSERT_PHONE_NUMBER, { state: { ...location.state, otp_use_only__subcampaign_id: data.subcampaign_id, engageSession: engage_session_id.current } });
        }
        if (couponType === CouponTypeEnum.TOKYU_POINTS) {

          const languagesData = { languages: languages };

          return navigate(
            links.LOYALTY_SUBMIT,
            {
              state: {
                ...location.state,
                subcampaignId: data.subcampaign_id,
                engageSession: engage_session_id.current,
                reward_banner: reward_banner,
                banner_image_corner,
                couponInstruction: qrscan_image,
                loyaltyMemberId: loyalty_member_id,
                languagesData: languagesData,
                isLoyaltySubmitted: is_loyalty_submitted
              }
            }
          );
        }
        else {
          setIsLoading(false);
        }
      }).catch((err) => {
        const errorMsg = err?.response?.data?.error_msg;
        if (errorMsg === "COUPON_FAILED") {
          return navigate(`${links.SMART_RETAIL_ERROR}?error-msg=coupon_failed`);
        }
        else if (errorMsg === "COUPON_ERROR")
          return navigate(`${links.SMART_RETAIL_ERROR}?error-msg=coupon_error`);
        else {
          setIsLoading(false);
        }
      });
    }
  }, [engage_session_id.current, isLoadedStatus, data.subcampaign_id]);


  const handleSelfService = (code: string) => {
    if (data.coupon_code && engage_session_id.current) {
      redeemSelfService({ engageSession: engage_session_id.current, ouCode: code, couponCode: data.coupon_code })
        .then(() => {
          window.location.reload();
          return;
        })
        .catch((err) => {
          const errorCode = err.response?.data?.err_code;
          if (errorCode && errorCode === "INVALID_OU_CODE") {
            setErrorMsg("INVALID_CODE");
          }
          else {
            setErrorMsg("INVALID_REQUEST");
          }
          return;
        });
    }
  };

  const onCam = () => {
    setIsScanQr(true);
  };

  const offCam = () => {
    setIsScanQr(false);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const setDialogInformation = (dialogInformation: any) => {
    setDialogInfo({
      ...dialogInformation,
      coupon_code: data?.coupon_code
    });
  };



  return (
    isScanQr
      ? (
        <>
          <QRScanner
            coupon_code={data?.coupon_code}
            setDialogInformation={setDialogInformation}
            handleDialogOpen={handleDialogOpen}
            offCam={offCam}
          />
          {
            openDialog
              ? (
                <QRCodeScanDialog
                  open={openDialog}
                  offCam={offCam}
                  onClose={handleDialogClose} {...dialogInfo}
                />
              )
              : ""
          }
        </>
      )
      : (
        <>
          {!showComponent && <Loading customBackgroundColor="rgba(255,255,255,1)" />}
          <AuthenticateLayout
            background={data?.reward_banner}
            isLoading={isLoading}
            hideLogo={ENV.HIDE_LOGO}
          // button={RewardButton}
          // coupon banner image should not depends on Banner Image Corner setting
          >
            {isLoading && <Loading />}
            <UseRewardWrapper>
              <Box className="body" sx={{ left: 0, top: 118 }}>
                <QRCodeWrapper>
                  {(!data?.coupon_used_option || data?.is_3rdparty_coupon_use) && <Loading customBackgroundColor="rgba(255,255,255,1)" />}
                  {data.coupon_used_option &&
                    <CouponUsedTypeContainer
                      data={data}
                      couponUsedOption={data.coupon_used_option}
                      used={used}
                      isExpired={isExpired}
                      qrscanImage={data?.qrscan_image}
                      languageData={data?.languages}
                    />}
                  {
                    data?.coupon_used_option &&
                    (!["QRSCANNER_FROM_CAMERA"].includes(data.coupon_used_option))
                    && <RedeemCodeContainer data={data} isExpired={isExpired} />
                  }
                </QRCodeWrapper>
                <FooterContainer
                  data={data}
                  used={used}
                  isExpired={isExpired}
                  engageSession={engage_session_id.current}
                  isScanQr={isScanQr}
                  onCam={onCam}
                  offCam={offCam}
                  onSelfRedeem={handleSelfService}
                  onSelfError={errorMsg}
                  onClearSelfError={clearError}
                />
              </Box>
            </UseRewardWrapper>
          </AuthenticateLayout>
        </>
      )
  );
};

export default UseReward2;
